import {
  faCog,
  faDatabase,
  faList,
  faTable,
  faWindowFlip,
} from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { computed } from "@preact/signals-react";
import { Chip } from "@progress/kendo-react-buttons";
import { DropDownTree } from "@progress/kendo-react-dropdowns";
import { templateData } from "../Template/NewTemplateSignals";

export const CustomDropDown = ({ handlePropertyChange, currentPropertyValues, propertyName }) => {
  const data = computed(() => {
    return templateData.value?.properties?.DataConnections?.map((dc) => dc) ?? [];
  });

  const customItem = ({ e }) => {
    if (e.item.title) return <div className="k-mt-2 k-mb-2 k-ml-2">{e.item.text}</div>;
    if (!e.item?.type) return;

    let icon = "";
    switch (e.item.type) {
      case "Template":
        icon = faWindowFlip;
        break;
      case "List":
        icon = faList;
        break;
      case "Global Parameters":
        icon = faCog;
        break;
      default:
        icon = faDatabase;
        break;
    }

    return (
      <Chip
        className="k-ml-0 k-p-0 !k-bg-transparent !k-border-none !k-w-full !k-h-full"
        onClick={() => {}}
      >
        <div className="k-d-flex">
          <FontAwesomeIcon
            className="k-mr-2 k-vertical-align-center"
            style={{
              "--fa-primary-color": "#0078d4",
              "--fa-secondary-color": "#a6e6ff",
              "--fa-secondary-opacity": 1,
            }}
            icon={icon}
            fontSize={16}
          />
          <span className="k-white-space-normal">{e.item.text}</span>
        </div>
      </Chip>
    );
  };

  const customValueHolder = (e) => {
    if (!e.item) return;

    let icon = "";
    switch (e.item.type) {
      case "Template":
        icon = faWindowFlip;
        break;
      case "List":
        icon = faList;
        break;
      case "Table":
        icon = faTable;
        break;
      case "Global Parameters":
        icon = faCog;
        break;
      default:
        icon = faDatabase;
        break;
    }

    return (
      <div className="k-d-flex">
        <FontAwesomeIcon
          className="k-mr-2 k-vertical-align-center"
          style={{
            "--fa-primary-color": "#0078d4",
            "--fa-secondary-color": "#a6e6ff",
            "--fa-secondary-opacity": 1,
          }}
          icon={icon}
          fontSize={16}
        />
        <span className={"k-white-space-normal"}>{e.item.text}</span>
      </div>
    );
  };

  return (
    <DropDownTree
      data={data.value}
      dataItemKey="id"
      textField="text"
      item={(e) =>
        customItem({
          e,
        })
      }
      adaptive={true}
      popupSettings={{ popupClass: "data-tree-popup" }}
      onChange={(e) => {
        handlePropertyChange({
          propName: propertyName,
          propValue: e.value ? e.value : null,
        });
      }}
      valueHolder={customValueHolder}
      value={currentPropertyValues?.[propertyName] || null}
    />
  );
};
